module.exports = __webpack_public_path__ + "static/media/arrow.781dce4e.svg";